import { PhaseTypeDto } from '../PhaseTypeDto';
import { FeeSheetRuleDto } from './FeeSheetRuleDto';
import { InfractionTypeDto } from '../infractions/InfractionTypeDto';
import { PhaseAliasDto } from '../PhaseAliasDto';

export interface FeeSheetRowDto {
  FeeSheetRowId: Guid;
  FeeSheetId: Guid;
  Description: string;
  PhaseTypeId?: number;
  InfractionTypeId?: Guid;
  PhaseAliasId?: Guid;
  PhaseType?: PhaseTypeDto;
  InfractionType?: InfractionTypeDto;
  PhaseAlias?: PhaseAliasDto;
  FeeSheetRules: FeeSheetRuleDto[];
  DeletedFeeSheetRules?: FeeSheetRuleDto[];
  Signed: boolean;
  CapDisplay: string;
  RowInfo?: ModifiedDetails;
UserNotes?: string | null;
  UserNotesUpdateDate?: Date | null;
  UserNotesUpdatedBy?: string | null
}
export interface ModifiedDetails {
  ModifiedDetails: Array<FeeSheetRowDetailEnum>;
  Status: FeeSheetRowStatusEnum;
}
export enum FeeSheetRowStatusEnum {
  New,
  Modified,
  UnModified
  
}
export enum FeeSheetRowDetailEnum {
  Description,
  Rule,
  Signed,
}
export interface FeeSheetRowNotesDto {
  Notes: string | null;
  FeeSheetRowId: Guid;
}

export enum FeeSheetRowTypeEnum {
  Phase = "Phase",
  Infraction = "Infraction"
}